import { render } from "./contact.info.list.vue?vue&type=template&id=7e289ba1"
import script from "./contact.info.list.vue?vue&type=script&lang=js"
export * from "./contact.info.list.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__